import React from 'react'
import { compose } from 'recompose'
import { inject, observer } from 'mobx-react'

import { IntlProvider, addLocaleData } from 'react-intl'
import enLocaleData from 'react-intl/locale-data/en'
import thLocaleData from 'react-intl/locale-data/th'

import enMessages from '~/App/i18n/en.json'
import thMessages from '~/App/i18n/th.json'

addLocaleData(enLocaleData)
addLocaleData(thLocaleData)

const messages = {
  en: enMessages,
  th: thMessages
}

const ConnectedIntlProvider = ({ i18n: { locale }, children }) => (
  <IntlProvider locale={locale} messages={messages[locale]}>
    {children}
  </IntlProvider>
)

export default compose(
  inject('i18n'),
  observer
)(ConnectedIntlProvider)



// WEBPACK FOOTER //
// ./src/App/providers/intl.js